// Initial search values
export const searchValues = {
  searchKey: "",
  toDate: new Date(new Date().setHours(23, 59, 59, 999)),
  project: "",
  toAmount: "",
  fromDate: new Date(new Date().setHours(0, 0, 0, 0)),
  fromAmount: "",
  paymentType: "",
  classificationId: "",
  columns: null,
};

// Excel header cells configuration
export const excelHeaderCellsName = {
  "تاريخ الإنشاء": "createdOn",
  "المعرف": "id",
  "الفئة": "attributeName",
  "عدد الاسهم": "count",
  "التصنيف": "classification",
  "اسم المستخدم": "userName",
  "نوع الدفع": "paymentType",
  "رقم الهاتف": "phoneNumber",
  "عنوان المشروع": "projectTitle",
  "المبلغ الإجمالي": "totalAmount",
  "اسم الحساب البنكي": "bankAccountName",
};
